export function hasSalesAccount(item) {
  var _item$xero$hasSalesAc, _item$xero;
  return (_item$xero$hasSalesAc = (_item$xero = item.xero) === null || _item$xero === void 0 ? void 0 : _item$xero.hasSalesAccount) !== null && _item$xero$hasSalesAc !== void 0 ? _item$xero$hasSalesAc : false;
}